import React from 'react';
import PromotionalHomeLegacy from '../components/displays/PromotionalHomeLegacy';

/** Presenter beta: previous promotional landing page. */
const PromotionalHomeLegacyBeta = () => <PromotionalHomeLegacy />;

export default PromotionalHomeLegacyBeta;
